import axios from 'axios'
import router from "../router";

axios.defaults.baseURL = process.env.BASE_URL_API_BACK;

axios.defaults.headers.post['TID'] = localStorage.getItem('TID');

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;

axios.defaults.withCredentials = true;

axios.interceptors.response.use(function(response) {
    return response;
}, function(error) {

	if(!!error.response.status) {
		switch (error.response.status) {
			case 401:
				Vue.prototype.$eventHub.$emit('showExpiredSession');
				break;
			case 500:
				Vue.prototype.$eventHub.$emit('showToastNotification', error.response.data);
				break;
			case 400:
				Vue.prototype.$eventHub.$emit('showToastNotification', error.response.data);
			case 403:
				if(error.response.data.has_accepted_terms === false){
					Vue.prototype.$eventHub.$emit('unacceptedTerms', error.response.data);
					Vue.prototype.$eventHub.$emit('onHideSpinner');
				}
				if(error.response.data.can_use_section === false){
					Vue.prototype.$eventHub.$emit('showToastNotification', error.response.data);
					router.push('/dashboard');
				}
		}
	}

	return Promise.reject(error);
});

/*
	const token = session.state.token;

	const { exp } = jwtDecode(token);

	var fechaDemo1 = new Date().getTime();
	var fechaDemo2 = new Date(exp).getTime();

	console.log(exp, fechaDemo1, fechaDemo2);

	var transcurso = fechaDemo1 - fechaDemo2;

	console.log(transcurso);

	var fechaDemo3 = new Date(transcurso).getMinutes();

	console.log(fechaDemo3);
*/

/*function getAuthToken () {
	// if the current store token expires soon
	  if (jwt(store.getters['auth/token']).exp - 240 <= (Date.now() / 1000).toFixed(0)) {
	  // if not already requesting a token
	  if (authTokenRequest === null) {
		 authTokenRequest = axios.post('/auth/refresh', {}, { withCredentials: true })
			  .then(response => {
			  // request complete and store
			  resetAuthTokenRequest()
			  store.commit('auth/refresh', response.data.access_token)
			  return response.data.access_token
			  })
		 }
		return authTokenRequest
	  }
	  return store.getters['auth/token']
 }
 
 // tokenRequest dirty bit reseter
 function resetAuthTokenRequest () {
	authTokenRequest = null
 }
 
 // Axios Intercept Requests
 axios.interceptors.request.use(async function (config) {
	// If not one of these specific pages that doesn't need a token, use method to get the current token or request a new one.  Otherwise, use current token (possibly none)
	if (!config.url.includes('login') && !config.url.includes('refresh') && !config.url.includes('forgot_password') && !config.url.includes('reset_password') && !config.url.includes('activate')) {
	  config.headers['Authorization'] = 'Bearer ' + await getAuthToken()
	} else {
	  config.headers['Authorization'] = 'Bearer ' + store.getters['auth/token']
	}
	return config
 }, function (error) {
	return Promise.reject(error)
 })
 
 axios.interceptors.response.use(function (config) {
	return config
 }, function (error) {
	// Prevent endless redirects (login is where you should end up)
	if (error.request !== undefined) {
	  if (error.request.responseURL.includes('login')) {
		 return Promise.reject(error)
	  }
	}
 
	// If you can't refresh your token or you are sent Unauthorized on any request, logout and go to login
	if (error.request !== undefined && (error.request.responseURL.includes('refresh') || error.request.status === 401 && error.config.__isRetryRequest)) {
	  store.dispatch('auth/logout')
	  router.push({name: 'Login'})
	} else if (error.request !== undefined && error.request.status === 401) {
	  error.config.__isRetryRequest = true
	  return axios.request(error.config)
	}
	return Promise.reject(error)
 })*/